// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2HViw","title":"ClientCherryInfo_title__qS36A","itemText":"ClientCherryInfo_itemText__2ZxdT"};